export default __webpack_public_path__ + "c4fe9f33b65dfc3fa452b6d4a1cada35.png";